import { createContext, useContext } from 'react';
export const PredictiveSearchResultContext = createContext(undefined);
export const PredictiveSearchContext = createContext({
    search: async () => { },
    reset: () => { },
    track: () => { },
});
export function usePredictiveSearchHandler() {
    return useContext(PredictiveSearchContext);
}
export function usePredictiveSearchResult() {
    return useContext(PredictiveSearchResultContext);
}
//# sourceMappingURL=predictive-search.js.map